function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { UserMenu } from '@/components/UserMenu';
import { faEllipsisV, faRightFromBracket } from '@fortawesome/free-solid-svg-icons';
import useChannelStore from '@/stores/ChannelStore';
import useAuthenticationStore from '@/stores/AuthenticationStore';
import { FormattedMessage } from 'react-intl';
import useLoginRedirect from '@/hooks/useLoginRedirect';
import { useShallow } from 'zustand/react/shallow';
import { Avatar, Button, Text } from '@mantine/core';
import styles from './UserMenuButton.module.scss';
import Icon, { IconSizes } from './Icon';
function UserMenuButton(props) {
    var _useChannelStore = useChannelStore(useShallow(function(state) {
        return {
            channel: state.channel,
            channelLoading: state.channelLoading
        };
    })), channel = _useChannelStore.channel, channelLoading = _useChannelStore.channelLoading;
    var user = useAuthenticationStore(function(state) {
        return state.user;
    });
    var loginRedirect = useLoginRedirect();
    var ref = React.useRef(null);
    var _React_useState = _sliced_to_array(React.useState({
        width: 0,
        height: 0
    }), 2), width = _React_useState[0].width, setDimensions = _React_useState[1];
    React.useEffect(function() {
        var handleResize = function handleResize() {
            if (ref.current == null) {
                return;
            }
            var _ref_current_getBoundingClientRect = ref.current.getBoundingClientRect(), width = _ref_current_getBoundingClientRect.width, height = _ref_current_getBoundingClientRect.height;
            setDimensions({
                width: width,
                height: height
            });
        };
        handleResize();
        window.addEventListener('resize', handleResize);
        return function() {
            window.removeEventListener('resize', handleResize);
        };
    }, []);
    if (channel == null && !channelLoading) {
        return /*#__PURE__*/ _jsx(Button, _object_spread_props(_object_spread({
            size: "lg",
            className: styles.button,
            leftSection: /*#__PURE__*/ _jsx(Icon, {
                size: IconSizes.SM,
                icon: faRightFromBracket
            }),
            onClick: loginRedirect
        }, props), {
            children: /*#__PURE__*/ _jsx(Text, {
                size: "md",
                className: styles.displayName,
                children: /*#__PURE__*/ _jsx(FormattedMessage, {
                    id: "AyGauy",
                    defaultMessage: "Login"
                })
            })
        }));
    }
    return /*#__PURE__*/ _jsx(UserMenu, _object_spread_props(_object_spread({
        withArrow: false,
        dropdownProps: {
            style: {
                width: width
            }
        }
    }, props), {
        children: /*#__PURE__*/ _jsx(Button, _object_spread_props(_object_spread({
            ref: ref,
            size: "lg",
            fullWidth: true,
            className: styles.buttonContainer,
            classNames: {
                root: styles.button,
                inner: styles.inner,
                label: styles.label
            },
            leftSection: /*#__PURE__*/ _jsx(Avatar, {
                size: "sm",
                src: channel === null || channel === void 0 ? void 0 : channel.avatar
            }),
            rightSection: /*#__PURE__*/ _jsx(Icon, {
                size: IconSizes.SM,
                icon: faEllipsisV
            })
        }, props), {
            children: /*#__PURE__*/ _jsxs("div", {
                className: styles.userStack,
                children: [
                    /*#__PURE__*/ _jsx(Text, {
                        truncate: true,
                        size: "md",
                        className: styles.displayName,
                        children: channel === null || channel === void 0 ? void 0 : channel.displayName
                    }),
                    user != null && channel != null && (user === null || user === void 0 ? void 0 : user._id) !== (channel === null || channel === void 0 ? void 0 : channel._id) ? /*#__PURE__*/ _jsx(Text, {
                        truncate: true,
                        size: "xs",
                        className: styles.viewingAs,
                        children: /*#__PURE__*/ _jsx(FormattedMessage, {
                            id: "27Bdra",
                            defaultMessage: "viewing as {displayName}",
                            values: {
                                displayName: user === null || user === void 0 ? void 0 : user.displayName
                            }
                        })
                    }) : null
                ]
            })
        }))
    }));
}
export default UserMenuButton;
